import { mapClient, } from "globalInstance"
import React, { useEffect, useState, } from "react"
import style from "./style.module.scss"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp"
import classnames from "classnames"

type Props = {
  currentFloor: Floor
  onChange: (floor: Floor) => void
}

export type Floor = {
  level: number
  label: string | null
}

/**
 * マップのフロア情報を表示するコンポーネントです
 */
function FloorSelector ({
  currentFloor,
  onChange,
}: Props) {
  const [floors, setFloors] = useState<Floor[]>([])
  const [isOpen, setIsOpen] = useState<boolean>(false)

  useEffect(() => {
    const levels = mapClient.getLevels().sort((a, b) => a - b).map(level => {
      return {
        level,
        label: mapClient.getFloorLabel(level),
      }
    })

    setFloors(levels)
  }, [])

  /**
   * UIからフロアを変更した際の処理
   * @param level
   */
  const handleLevelChange = (newFloor: Floor) => {
    if (onChange) onChange(newFloor)
    setIsOpen(false)
  }

  return (
    <div className={style.frame} onClick={() => setIsOpen(!isOpen)}>
      <div className={style.floorList}>
        {(isOpen)
          ? (<div>{floors.map((floor, key) => {
              return (
                <div
                  key={key}
                  className={classnames({
                    [style.item]: true,
                    [style.selected]: (floor.level === currentFloor.level),
                  })}
                  onClick={() => handleLevelChange(floor)}>
                  {(floor.label) && floor.label}
                </div>
              )
            })}
            <div className={classnames(style.item, style.arrow)}>
              <ArrowDropUpIcon/>
            </div></div>)
          : (<div>
              <div className={classnames({
                [style.item]: true,
                [style.selected]: true,
              })}>
                {(currentFloor && currentFloor.label) && currentFloor.label}
              </div>
              <div className={classnames(style.item, style.arrow)}>
                <ArrowDropDownIcon/>
              </div>
            </div>)}
      </div>
    </div>
  )
}

export default FloorSelector
